import React, { Component } from 'react';
import { connect } from 'react-redux';

import { answerQuestion } from '../../../../../_actions/questionnaire.actions';

class OpenChoiceType extends Component {
  constructor(props) {
    super(props)

    this.optionsRefs = [];
    this.setOptionsRefs = element => {
      this.optionsRefs.push(element);
    }

    this.otherRef = null;
    this.setOtherRef = element => {
      this.otherRef = element;
    }

    this.state = {
      options: props.question.answerOption,
      selected: [],
      otherOption: false,
      otherValue: null
    }

    this.handleOther = this.handleOther.bind(this);
    this.handleOtherValue = this.handleOtherValue.bind(this);

    this.handleSelection = this.handleSelection.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.question.answerOption) !== JSON.stringify(this.props.question.answerOption)) {
      this.setState({
        otherOption: this.props.question.answerOption.length === 0 && this.state.otherOption ? true : false,
        options: this.props.question.answerOption
      });
    }
  }

  handleSelection(e) {
    let isChecked = e.target.checked;
    let selected = this.state.selected;

    const itemControl = this.props.question.extension.find((extension) => {
      return extension.url === "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl"
    });

    if (isChecked) {
      if (itemControl.valueCodeableConcept.coding[0].code === 'check-box') {
        selected.push(e.target.value);
      } else {
        selected = new Array(e.target.value)
      }
    } else {
      if (itemControl.valueCodeableConcept.coding[0].code === 'check-box') {
        selected.splice(selected.indexOf(e.target.value), 1);
      } else {
        selected = [];
      }
    }

    this.otherRef.checked = false;

    this.props.dispatch(answerQuestion(this.props.question, selected));

    this.setState({
      selected: selected,
      otherOption: false,
      otherValue: null
    });
  }

  handleOther() {
    this.state.options.forEach((option, i) => {
      this.optionsRefs[i].checked = false;
    });


    this.setState({
      selected: [],
      otherOption: !this.state.otherOption
    });
  }

  handleOtherValue(e) {
    this.props.dispatch(answerQuestion(this.props.question, e.target.value));
  }

  render() {
    let { question } = this.props;

    const itemControl = question.extension.find((extension) => {
      return extension.url === "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl"
    });

    const choiceType = itemControl.valueCodeableConcept.coding[0].code === 'check-box' ? 'checkbox' : 'radio';

    return <>
      <h6 className="card-title">{question.linkId}. {question.text || 'Enter your question.'}</h6>

      {this.state.options.length === 0 &&
        <strong>No options...</strong>
      }

      {this.state.options.map((option, i) => {
        return <div key={i} className="form-check">
          <input
            ref={this.setOptionsRefs}
            id={`openchoice_${question.linkId}_${i}`}
            onClick={this.handleSelection}
            value={option.valueCoding.code}
            className="form-check-input"
            type={choiceType}
            name={`openchoice_${question.linkId}`}
          />

          <label
            htmlFor={`openchoice_${question.linkId}_${i}`}
            className="form-check-label"
          >{option.valueCoding.code}</label>
        </div>
      })}

      {this.state.options.length !== 0 &&
        <div className="form-check">
          <input
            onClick={this.handleOther}
            ref={this.setOtherRef}
            id={`openchoice_other_${question.linkId}`}
            className="form-check-input"
            type="checkbox"
          />
          <label
            htmlFor={`openchoice_other_${question.linkId}`}
            className="form-check-label"
          >Other</label>
        </div>
      }

      {this.state.otherOption && <div className="form-group">
        <input onChange={this.handleOtherValue} type="text" className="form-control" />
      </div>
      }
    </>;
  }
}

export default connect()(OpenChoiceType);